/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_AnalyticsInputs */

const en_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Analytics`)
};

const es_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis avanzados`)
};

const fr_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses avancées`)
};

const de_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte Analysen`)
};

const ja_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高度なアナリティクス`)
};

const zh_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级数据分析`)
};

const ar_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليلات متقدمة`)
};

const id_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analitik Lanjutan`)
};

const it_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analitiche Avanzate`)
};

const ru_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продвинутая аналитика`)
};

const pt_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análises Avançadas`)
};

const ko_pricing_feature_analytics = /** @type {(inputs: Pricing_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고급 분석`)
};

/**
* | output |
* | --- |
* | "Advanced Analytics" |
*
* @param {Pricing_Feature_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_analytics = /** @type {((inputs?: Pricing_Feature_AnalyticsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_AnalyticsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_analytics(inputs)
	if (locale === "es") return es_pricing_feature_analytics(inputs)
	if (locale === "fr") return fr_pricing_feature_analytics(inputs)
	if (locale === "de") return de_pricing_feature_analytics(inputs)
	if (locale === "ja") return ja_pricing_feature_analytics(inputs)
	if (locale === "zh") return zh_pricing_feature_analytics(inputs)
	if (locale === "ar") return ar_pricing_feature_analytics(inputs)
	if (locale === "id") return id_pricing_feature_analytics(inputs)
	if (locale === "it") return it_pricing_feature_analytics(inputs)
	if (locale === "ru") return ru_pricing_feature_analytics(inputs)
	if (locale === "pt") return pt_pricing_feature_analytics(inputs)
	return ko_pricing_feature_analytics(inputs)
});